import * as apis from "@/api";
import { conversion, GetItemDuration } from "@/tool";
import { mapState, mapMutations } from "vuex";
import Award from "@/components/UI/award";
import Number from "@/components/AnimateNumber";

export default {
  components: {
    "c-award": Award,
    "c-number": Number,
  },
  data() {
    return {
      isShow: false,
      isGameInstance: false,
      case_opened_awards: [],
      bgPos: 0,
      gameInstance_info: {},
      unpackgameInstance_item_show: false,
    };
  },
  props: {
    //当时case页面传入case_info
    case_info: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      defalut: "accumulate",
    },
  },

  filters: {
    conversion,
    GetItemDuration,
  },
  computed: {
    ...mapState(["sellSound", "isMute"]),
    /** 开箱结果奖品金额合计 */
    case_opened_awards_amount: (vm) =>
      vm.case_opened_awards
        .filter((_) => !_.isConvert)
        .reduce((acc, { price }) => acc + price, 0),
  },
  methods: {
    reset() {
      this.case_opened_awards = [];
      this.isShow = false;
    },
    //避开reset再case详情页初始化，如果是宝箱关闭，将消息传回父组件中，
     onCloseHandle() {
      this.case_opened_awards = [];
      this.isShow = false;
      // console.log('关闭')
      this.$emit("on-onRewardModalCloseHandle", {
        isRewardShow: false,
        boxType: this.type,
      });
    },
    resetItem(index) {
      this.case_opened_awards[index].isConvert = true;
      if (this.case_opened_awards_amount <= 0) {
        this.reset();
      }
    },
    pushItem(name, mSerial, itempic, rarity, price, roll) {
      var typename = name.match(/^(.*?)\s?(\(.*\))?$/)[1];
      var skinname = "";
      var dur = GetItemDuration(name);
      var strArr = typename.split("|");
      if (strArr.length > 1) {
        typename = strArr[0];
        skinname = strArr[1];
      }

      this.case_opened_awards.push({
        name: name,
        typename,
        skinname,
        dur,
        mSerial,
        itempic,
        rarity,
        price,
        isConvert: false,
        roll,
      });
    },
    async show() {
      this.bgPos = Math.floor(Math.random() * 100) % 3;
      //如果是case传入,并且是副本箱的母箱的话
      if (
        this.case_info &&
        this.case_info.caseId &&
        this.case_info.extraCaseId
      ) {
        //获取副本箱详情
        await this.getGameInstance();
        this.isGameInstance = true;
        this.isShow = true;
      } else {
        this.isShow = true;
      }
    },
    /** 开箱奖品折现 */
    async case_opened_awards_discount(award) {
      var awards_Serial = this.case_opened_awards
        .filter((_) => !_.isConvert)
        .map((award) => award.mSerial);

      if (award) {
        awards_Serial = [award.mSerial];
      }

      const awards_discount_response = await apis.api_SellItem({
        lstmSerial: awards_Serial,
      });

      // 折现失败
      if (awards_discount_response.data.code !== 0) {
        this.$toast.error(awards_discount_response.data.msg);
        return;
      }

      // if(!this.isMute){
			// 	this.sellSound.pause();
			// 	this.sellSound.currentTime=0;
			// 	this.sellSound.play();
			// }

      //this.awards_modal_flag = false;

      this.$toast.success(awards_discount_response.data.msg, {
        timeout: 2000,
      });

      // 更新用户信息
      this.$store.commit("setInfo");

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.isConvert = true;
        }
      });
      // console.log('this.case_opened_awards_amount==',this.case_opened_awards_amount)
      if (this.case_opened_awards_amount <= 0) {
        this.reset();
        this.$emit("on-onRewardModalCloseHandle", {
          isRewardShow: false,
          boxType: this.type,
        });
      }
    },
    //获取副本箱详情
    async getGameInstance() {
      const gameInstance_response = await apis.api_CaseDetail(
        this.case_info.extraCaseId
      );
      if (gameInstance_response.data.code !== 0) {
        return;
      }
      const respone = gameInstance_response.data.data;
      this.gameInstance_info = respone.caseInfo;
    },
  },
};
